import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from './utils/api';
import PageHeader from './components/PageHeader';

function RamsSitesPage() {
  const navigate = useNavigate();
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchSites();
  }, []);

  const fetchSites = async () => {
    setLoading(true);
    try {
      // Fetch sites that have RAMS documents
      const res = await apiFetch('/api/sites');
      if (res.ok) {
        const data = await res.json();
        setSites(Array.isArray(data) ? data : (data.sites || []));
      }
    } catch (err) {
      console.error('Error fetching sites:', err);
    }
    setLoading(false);
  };

  const viewSiteRams = (siteId) => {
    navigate(`/rams/sites/${siteId}`);
  };

  const filtered = sites.filter(s => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      (s.site_name || '').toLowerCase().includes(term) ||
      (s.address || '').toLowerCase().includes(term) ||
      (s.postcode || '').toLowerCase().includes(term)
    );
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="RAMS Site History"
        subtitle="Sites with risk assessments & method statements"
        backTo="/rams"
        backLabel="RAMS"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-white rounded-lg shadow p-4 mb-6 border border-gray-200">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search sites by name, address, postcode..."
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:border-blue-500 focus:outline-none"
          />
        </div>

        <div className="bg-white rounded-lg shadow border border-gray-200">
          {loading ? (
            <div className="p-8 text-center text-gray-500">Loading sites...</div>
          ) : filtered.length === 0 ? (
            <div className="p-8 text-center text-gray-500">No sites found.</div>
          ) : (
            <div className="divide-y divide-gray-100">
              {filtered.map((s) => (
                <div
                  key={s.id}
                  className="px-6 py-4 hover:bg-gray-50 cursor-pointer"
                  onClick={() => viewSiteRams(s.id)}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-800 text-sm">
                        {s.site_name || 'Unnamed Site'}
                      </h3>
                      <div className="text-xs text-gray-500 mt-1">
                        {[s.address, s.city, s.postcode].filter(Boolean).join(', ')}
                      </div>
                    </div>
                    <span className="text-blue-600 text-xs">View RAMS →</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default RamsSitesPage;
